import { HttpErrorResponse } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import {
  FormBuilder,
  FormControl,
  FormGroup,
  FormsModule,
  ReactiveFormsModule,
} from '@angular/forms';
import { MatError, MatFormField, MatLabel } from '@angular/material/form-field';
import { MatIcon } from '@angular/material/icon';
import { MatInput } from '@angular/material/input';
import { ActivatedRoute } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import { ApiServiceService } from '../api-service.service';
import { SharedValidators } from '../shared/validators/shared-validators';
@Component({
  selector: 'app-device-model-details',
  templateUrl: './device-model-details.component.html',
  styleUrls: ['./device-model-details.component.scss'],
  standalone: true,
  imports: [
    FormsModule,
    ReactiveFormsModule,
    MatFormField,
    MatLabel,
    MatInput,
    MatError,
    MatIcon,
  ],
})
export class DeviceModelDetailsComponent implements OnInit {
  modelFirmwareForm: FormGroup = this.formBuilder.group({});
  loggedId = '';
  modelId = '';
  userPermission = [];
  ModelFirmwareCreate = true;
  ModelFirmwareUpdate = true;
  ModelFirmwareDelete = false;
  ModelFirmwarePermissionCreate = false;
  ModelFirmwarePermissionUpdate = false;
  constructor(
    public apiMicroservice: ApiServiceService,
    private formBuilder: FormBuilder,
    private route: ActivatedRoute,
    private spinner: NgxSpinnerService
  ) {}

  ngOnInit(): void {
    this.setModelFirmwarePageForm();
    this.checkPermission();
    if (
      this.ModelFirmwarePermissionCreate ||
      this.ModelFirmwarePermissionUpdate
    ) {
      if (this.modelId !== null) {
        this.ModelFirmwareUpdate = true;
        this.ModelFirmwareCreate = false;
        this.prePopulation(this.modelId);
      } else {
        this.ModelFirmwareUpdate = false;
        this.ModelFirmwareCreate = true;
      }
    }
  }

  checkPermission() {
    this.modelId = this.route.snapshot.paramMap.get('modelId');
    this.loggedId = this.apiMicroservice.decryptData(
      sessionStorage.getItem('userRefId') || ''
    );
    this.userPermission = JSON.parse(
      this.apiMicroservice.decryptData(
        sessionStorage.getItem('userPermission') || '[]'
      )
    );
    this.userPermission.forEach(
      (element: {
        pageName: string;
        view: boolean;
        create: boolean;
        delete: boolean;
        update: boolean;
      }) => {
        if (
          element.pageName === 'Device Model' &&
          element.create === false &&
          element.update === false
        ) {
          this.navigateBack();
        }
        if (element.pageName === 'Device Model' && element.create === true) {
          this.ModelFirmwarePermissionCreate = true;
        }
        if (element.pageName === 'Device Model' && element.update === true) {
          this.ModelFirmwarePermissionUpdate = true;
        }
        if (element.pageName === 'Device Model' && element.delete === true) {
          this.ModelFirmwareDelete = true;
        }
      }
    );
  }

  setModelFirmwarePageForm() {
    this.modelFirmwareForm = this.formBuilder.group({
      modelName: new FormControl('', [
        SharedValidators.requiredAndNoEmptySpaces,
      ]),
      modelCode: new FormControl('', [
        SharedValidators.requiredAndNoEmptySpaces,
      ]),
      hwVersion: new FormControl('', [
        SharedValidators.requiredAndNoEmptySpaces,
      ]),
    });
  }

  prePopulation(id) {
    this.spinner.show();
    this.apiMicroservice.getFirmwareDataById(id).subscribe((res) => {
      this.spinner.hide();
      const data = res.data[0];
      if (res.status) {
        this.modelFirmwareForm = this.formBuilder.group({
          modelName: new FormControl(data.modelName, [
            SharedValidators.requiredAndNoEmptySpaces,
          ]),
          modelCode: new FormControl(data.modelCode, [
            SharedValidators.requiredAndNoEmptySpaces,
          ]),
          hwVersion: new FormControl(data.hwVersion, [
            SharedValidators.requiredAndNoEmptySpaces,
          ]),
        });
      }
    });
  }

  validateFormUpdate() {
    if (this.modelFirmwareForm.invalid) {
      SharedValidators.markAllAsTouched(this.modelFirmwareForm);
    } else {
      this.updateData();
    }
  }

  validateFormSave() {
    if (this.modelFirmwareForm.invalid) {
      SharedValidators.markAllAsTouched(this.modelFirmwareForm);
    } else {
      this.saveData();
    }
  }

  saveData() {
    this.spinner.show();
    const payload = this.modelFirmwareForm.value;
    payload.createdAt = Date.now();
    this.apiMicroservice.saveFirmware(payload).subscribe({
      next: (res) => {
        if (res.status) {
          this.navigateBack();
          this.apiMicroservice.openSnackbar(res.message);
        } else {
          this.spinner.hide();
        }
      },
      error: (ERROR: HttpErrorResponse) => {
        this.spinner.hide();
        this.apiMicroservice.openSnackbar(ERROR.error.message);
      },
    });
  }

  updateData() {
    this.spinner.show();
    const payload = this.modelFirmwareForm.value;
    payload.id = this.modelId;
    payload.updatedAt = Date.now();
    this.apiMicroservice.updateFirmwareData(this.modelId, payload).subscribe({
      next: (res) => {
        this.spinner.hide();
        if (res.status) {
          this.navigateBack();
          this.apiMicroservice.openSnackbar(res.message);
        } else {
          this.apiMicroservice.openSnackbar(res.message);
        }
      },
      error: (ERROR: HttpErrorResponse) => {
        this.spinner.hide();
        this.apiMicroservice.openSnackbar(ERROR.error.message);
      },
    });
  }

  navigateBack() {
    this.apiMicroservice.back();
  }
}
